import "./App.css";

import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  BrowserRouter,
  Form,
} from "react-router-dom";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Projects from "./pages/Projects";
import ThankYou from "./pages/ThankYou";
import DynamicPage from "./components/meta/DynamicPage";
import Services from "./pages/Services";

export default function App() {
  return (
    <>
      <DynamicPage title="Hemsida Web Development" />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/About" element={<About />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/Projects" element={<Projects />} />
        <Route path="/ThankYou" element={<ThankYou />} />
        <Route path="/Services" element={<Services />} />
      </Routes>
    </>
  );
}
